import Axios from "axios";

import Store from "@/store";

// API_PATH is defined externally
/* global API_PATH */

export default class API {
  static IsLoggedIn() {
    return Store.state.apitoken !== undefined && Store.state.apiexpiration > Date.now();
  }

  static async AuthedRequest(method, route, data) {
    if (!Store.state.apitoken || !Store.state.apiexpiration || Store.state.apiexpiration < Date.now()) {
      await Store.dispatch("Logout");
      return;
    }
    const token = Store.state.apitoken;
    const result = await Axios({
      method,
      url: API_PATH + route,
      data,
      headers: {
        "Content-Type": "application/json",
        "Authorization": "Bearer " + token,
      },
    });
    return result.data;
  }

  static async Login(email, password) {
    const result = await Axios.post(API_PATH + "/auth/user", { email, password });
    Store.commit("SetToken", result.data.token);
    Store.commit("SetExpiration", result.data.expiration);
    Store.commit("SetEmail", email);
    Store.commit("SetRole", result.data.role);
    return result.data.token;
  }

  static async Forgot(email) {
    await Axios.post(API_PATH + "/auth/forgot", { email });
  }

  static async Reset(email, code, newpassword) {
    await Axios.post(API_PATH + "/auth/reset", { email, code, newpassword });
  }

  static async GetAPIVersion() {
    const response = await Axios.get(API_PATH + "/gitversion");
    return response.data.version;
  }

  static async GetClientVersion() {
    try {
      // Must add transformer because otherwise it may get parsed as numeric
      const response = await Axios.get("/gitversion.txt", { transformResponse: data => data });
      return response.data;
    } catch (err) {
      return "dev";
    }
  }

  static async CreatePreregister(participant) {
    await Axios.post(API_PATH + "/preregister", participant);
  }

  static async GetLocations(filter = "") {
    const response = await this.AuthedRequest("GET", "/user/locations?filter=" + encodeURIComponent(filter));
    return response;
  }

  static async GetParticipants(filter = "", onlyUnclaimed = true) {
    const response = await this.AuthedRequest("GET", "/user/participants?filter=" + encodeURIComponent(filter) + "&unclaimed=" + onlyUnclaimed.toString());
    return response;
  }

  static async GetParticipant(id) {
    const response = await this.AuthedRequest("GET", "/user/participants/" + id);
    return response;
  }

  static async GetParticipantAttendance(id) {
    const response = await this.AuthedRequest("GET", "/user/participants/" + id + "/attendance");
    return response;
  }

  static async CreateParticipantAttendance(participantId, locationId, locationName) {
    await this.AuthedRequest("POST", "/user/participants/" + participantId + "/attendance", { locationId, locationName });
  }

  static async GetParticipantSkis(id) {
    const response = await this.AuthedRequest("GET", "/user/participants/" + id + "/skis");
    return response;
  }

  static async CreateParticipantSki(participantid, ski) {
    await this.AuthedRequest("POST", "/user/participants/" + participantid + "/skis", ski);
  }

  static async UpdateParticipantSki(id, ski) {
    await this.AuthedRequest("PUT", "/user/skis/" + id, ski);
  }

  static async DeleteParticipantSki(id) {
    await this.AuthedRequest("DELETE", "/user/skis/" + id);
  }

  static async GetSkiTypes() {
    const response = await this.AuthedRequest("GET", "/user/skitypes");
    return response;
  }

  static async GetUnreturnedSkis(filter = "") {
    const response = await this.AuthedRequest("GET", "/user/unreturnedskis?filter=" + encodeURIComponent(filter));
    return response;
  }

  // Admin
  static async RunReport(start, end) {
    const result = await this.AuthedRequest("POST", "/admin/report", { start, end });
    DownloadFile("Demo Export " + start + " to " + end + ".csv", result);
    return;
  }
}

function DownloadFile(filename, data) {
  const url = window.URL.createObjectURL(new Blob([data]));
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();
}
